export default __webpack_public_path__ + "static/media/diabetic-care.8ae53a00.png";